import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form } from 'antd';

import { useWorkstations } from '@/components/views/PreliminaryAnalysis/hooks';
import { WorkstationSelect } from '@/components/ui/Inputs/WorkstationSelect';
import { useApplicationContext } from '@/context/v1/Application/context';

const { useFormInstance, useWatch } = Form;

export const Workstations = () => {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const lineId = useWatch(['file', 'line_id'], form);
	const workstationId = useWatch(['file', 'workstation_id'], form);

	const {
		data: workstations,
		isLoading,
		isFetching,
		isError
	} = useWorkstations(organization?.id, company?.id, lineId);

	function handleWorkstationSelect(id: string) {
		form.setFieldValue(['file', 'workstation_id'], id);
	}

	function handleClearWorkstations() {
		form.setFieldValue(['file', 'workstation_id'], undefined);
	}

	return (
		<Col span={12}>
			<Form.Item
				name={['file', 'workstation_id']}
				label={I18n.get('Workstation')}
				rules={[
					{
						required: true,
						message: I18n.get('Select the workstation')
					}
				]}
			>
				<WorkstationSelect
					lineId={lineId}
					loading={isFetching}
					workstations={workstations}
					workstationId={workstationId}
					fieldName={['file', 'workstation_id']}
					disabled={isLoading || isFetching || isError}
					handleSelectWorkstation={handleWorkstationSelect}
					handleClearWorkstations={handleClearWorkstations}
				/>
			</Form.Item>
		</Col>
	);
};
